// extracted by mini-css-extract-plugin
export default {"back":"activationApply_back__POqXg"};